@for (item of items(); track dataKey() ? item[dataKey()] : $index; let index = $index) {
  <sxw-checkbox-input
    [item]="item"
    [valueKey]="valueKey()"
    [labelKey]="labelKey()"
    [disabled]="disabled"
    [readonly]="readonly"
    [(ngModel)]="value"
    [groupName]="groupName()"
    [theme]="checkboxTheme()"
    [styles]="checkboxStyles()"
    [size]="size()"
    [binary]="false"
    [checkboxIcon]="checkboxIcon()"
    (ngModelChange)="checkboxChangeHandler($event)"
    [inputId]="inputId() + (valueKey() ? item[valueKey()!] + '' : labelKey() ? item[labelKey()!] + '' : '' + '-' + index)">
    @if (customTemplate()) {
      <ng-template #checkboxItemTemplate let-item let-checked="checked">
        <ng-container [ngTemplateOutlet]="customTemplate()!" [ngTemplateOutletContext]="{ $implicit: item, checked }"></ng-container>
      </ng-template>
    }
  </sxw-checkbox-input>
}

@if (isInvalidControl) {
  <div>
    <sxw-error-message [message]="control ? control.errors : null"></sxw-error-message>
  </div>
}
